var map = {
	"./img/11logo.png": 450,
	"./img/3logo.png": 8866,
	"./img/404.png": 5747,
	"./img/about-2-bg.jpg": 9248,
	"./img/about-2.jpg": 8602,
	"./img/about-3.jpg": 8353,
	"./img/about-header.jpg": 4309,
	"./img/about-homecare.jpg": 6072,
	"./img/about-homecare2.jpg": 4589,
	"./img/about-homecaree.jpg": 5939,
	"./img/about.jpg": 1016,
	"./img/ahp.jpg": 3322,
	"./img/banner-poster.jpg": 1066,
	"./img/blog/01.jpg": 3241,
	"./img/blog/02.jpg": 308,
	"./img/blog/03.jpg": 8170,
	"./img/blog/04.jpg": 7493,
	"./img/blog/05.jpg": 9819,
	"./img/blog/06.jpg": 3351,
	"./img/blog/07.jpg": 6392,
	"./img/blog/08.jpg": 2404,
	"./img/blog/09.jpg": 4470,
	"./img/blog/10.jpg": 3081,
	"./img/blog/11.jpg": 9803,
	"./img/blog/12.jpg": 8593,
	"./img/blog/13.jpg": 1354,
	"./img/blog/14.jpg": 9421,
	"./img/blog/15.jpg": 1373,
	"./img/blurrylogo.png": 3685,
	"./img/brand-logo/01-copy.png": 7934,
	"./img/brand-logo/01.png": 3077,
	"./img/brand-logo/02.png": 4572,
	"./img/brand-logo/03.png": 4553,
	"./img/brand-logo/04.png": 2353,
	"./img/brand-logo/05.png": 6449,
	"./img/businessmen-handshake.jpg": 4699,
	"./img/careforadults.jpg": 1771,
	"./img/careforchildren.jpg": 9600,
	"./img/clearsmalllogo.png": 9146,
	"./img/construction.jpg": 7002,
	"./img/demo-page/bootstrap.png": 7707,
	"./img/demo-page/code.png": 7914,
	"./img/demo-page/coming-soon.jpg": 6036,
	"./img/demo-page/document.png": 2886,
	"./img/demo-page/fontawesome.png": 3757,
	"./img/demo-page/google-font.png": 8098,
	"./img/demo-page/jquery.png": 9523,
	"./img/demo-page/pages/about.jpg": 1024,
	"./img/demo-page/pages/blog-details-sidebar.jpg": 5093,
	"./img/demo-page/pages/blog-details.jpg": 6647,
	"./img/demo-page/pages/blog-grid.jpg": 6617,
	"./img/demo-page/pages/blog-l-g.jpg": 4405,
	"./img/demo-page/pages/blog-l-l.jpg": 6728,
	"./img/demo-page/pages/blog-l-r.jpg": 2682,
	"./img/demo-page/pages/blog-r-g.jpg": 745,
	"./img/demo-page/pages/contact.jpg": 2962,
	"./img/demo-page/pages/home-1.jpg": 9792,
	"./img/demo-page/pages/home-2.jpg": 4218,
	"./img/demo-page/pages/service-details.jpg": 9904,
	"./img/demo-page/pages/service.jpg": 8311,
	"./img/demo-page/pages/team-details.jpg": 2310,
	"./img/demo-page/pages/team.jpg": 2772,
	"./img/demo-page/react.svg": 2544,
	"./img/demo-page/responsive.png": 422,
	"./img/demo-page/sass.png": 8857,
	"./img/demo-page/slick.jpg": 3310,
	"./img/demo-page/slider-bg.jpg": 6914,
	"./img/demo-page/speed.png": 8173,
	"./img/demo-page/support.png": 6004,
	"./img/doctor.jpg": 1502,
	"./img/educationn.jpg": 8004,
	"./img/feature/01.png": 303,
	"./img/feature/02.png": 7591,
	"./img/feature/03.png": 7690,
	"./img/fun-fact-bg.jpg": 502,
	"./img/fun-fact-bgtest.jpg": 1884,
	"./img/fundingpathways.jpg": 5835,
	"./img/gp.jpg": 4466,
	"./img/healthcare-landing.jpg": 3096,
	"./img/healthcare.jpeg": 1742,
	"./img/healthcare.jpg": 7723,
	"./img/home.jpeg": 2954,
	"./img/homecare-landing.jpg": 3826,
	"./img/homecare-services.jpg": 8296,
	"./img/homecare-services2.jpg": 1939,
	"./img/homecare.jpg": 8698,
	"./img/homecare2.jpg": 5482,
	"./img/hospitality.jpg": 5196,
	"./img/icons/cancel-white.png": 659,
	"./img/icons/cancel.png": 3797,
	"./img/icons/coloredbg.png": 7202,
	"./img/icons/loader.gif": 4637,
	"./img/icons/quote.png": 719,
	"./img/landing-healthcare.jpg": 98,
	"./img/landing.jpg": 3932,
	"./img/learningdiff.jpg": 8265,
	"./img/lgg.jpg": 4607,
	"./img/lggg.jpg": 3976,
	"./img/logistics-header.jpg": 455,
	"./img/logistics.jpg": 8997,
	"./img/logo-dark.png": 8750,
	"./img/logo.png": 5080,
	"./img/medical-banner-with-doctor-wearing-glove.jpg": 8926,
	"./img/nurse.jpg": 1836,
	"./img/page-header.jpg": 1109,
	"./img/qwwpage-header.jpg": 179,
	"./img/rapidresponse.jpg": 76,
	"./img/req.jpeg": 8345,
	"./img/service/01.jpg": 5114,
	"./img/service/011.jpg": 490,
	"./img/service/02.jpg": 5437,
	"./img/service/022.jpg": 5909,
	"./img/service/02test.jpg": 3428,
	"./img/service/03.jpg": 1019,
	"./img/service/04.jpg": 9632,
	"./img/service/05.jpg": 2181,
	"./img/service/06.jpg": 3995,
	"./img/service/details/01.jpg": 2623,
	"./img/service/details/03.jpg": 6358,
	"./img/service/icon/analysis.png": 1774,
	"./img/service/icon/research.png": 1573,
	"./img/service/icon/strategy.png": 1957,
	"./img/service/icon/track-record.png": 9380,
	"./img/servicestwo.jpg": 9517,
	"./img/slider/01.jpg": 1255,
	"./img/slider/01.mp4": 8549,
	"./img/slider/011.jpg": 4614,
	"./img/slider/02.jpg": 8424,
	"./img/slider/11.jpg": 6123,
	"./img/slider/homecare.jpg": 951,
	"./img/slider/homecare2.jpg": 9135,
	"./img/spc_logo.png": 4708,
	"./img/supportedliving.jpg": 7367,
	"./img/team/01.jpg": 7569,
	"./img/team/02.jpg": 4722,
	"./img/team/03.jpg": 2390,
	"./img/team/04.jpg": 1901,
	"./img/team/05.jpg": 5724,
	"./img/team/06.jpg": 9856,
	"./img/team/details/date-1.png": 4486,
	"./img/team/details/date-2.png": 8892,
	"./img/team/details/date-3.png": 9587,
	"./img/team/h-2-01.png": 3878,
	"./img/team/h-2-02.png": 2076,
	"./img/team/h-2-03.png": 7650,
	"./img/team/h-2-04.png": 4843,
	"./img/team/team-arrow.png": 8477,
	"./img/team/team-bg-2.jpg": 3119,
	"./img/team/team-bg.jpg": 3843,
	"./img/team/team-details.jpg": 9171,
	"./img/testimonial/CIC-ISO-9001-QM.png": 7857,
	"./img/testimonial/bg-dot.png": 4299,
	"./img/testimonial/certificate1.png": 9112,
	"./img/testimonial/certificate2.png": 5810,
	"./img/testimonial/certificate3.png": 6198,
	"./img/testimonial/certificate4.png": 9175,
	"./img/testimonial/certificate5.png": 5594,
	"./img/testimonial/client-01.jpg": 1726,
	"./img/testimonial/client-02.jpg": 6337,
	"./img/testimonial/client-03.jpg": 538,
	"./img/testimonial/h-2-t-01.png": 1689,
	"./img/testimonial/h-2-t-02.png": 8635,
	"./img/testimonial/h-2-t-03.png": 1751,
	"./img/testlogo.png": 6032,
	"./img/truck.jpg": 5507,
	"./img/wave.svg": 2866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7528;